import React from 'react';
import { parseClasses } from '../../lib/ep.js';

import DisablerElement from './DisablerElement';

const DisabledArea = (props) => {
	const disabled = props?.disabled ?? false;
	const tooltip = props?.message ?? "";
	let classname = props?.classname ?? 'fields_grouper';
	if(disabled) classname += ' gui_disabledItem';
	classname = parseClasses(classname, props._class, 'disabled_area');

	return (
		<div class={classname}>
			{props.children}

			{(disabled) && (
				<DisablerElement
					link={props.link}
					link_label={props.link_label}
					tooltip_position={props.tooltip_position}
					tooltip_autotranslate={props.autotranslate}
					display_inlined={props.display_inlined}
				>{tooltip}</DisablerElement>
			)}
		</div>
	);
}

export default DisabledArea;